import { render, staticRenderFns } from "./ProcesoCompraAmigoAbonado.vue?vue&type=template&id=5ca13b1e"
import script from "./ProcesoCompraAmigoAbonado.vue?vue&type=script&lang=js"
export * from "./ProcesoCompraAmigoAbonado.vue?vue&type=script&lang=js"
import style0 from "./ProcesoCompraAmigoAbonado.vue?vue&type=style&index=0&id=5ca13b1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports